module.exports = __webpack_public_path__ + "static/media/MIM2CRV.5923c1d1.svg";